import PageHeader from "@/components/PageHeader";
import ParoleView from "@/components/ParoleView";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Crosshair } from "lucide-react";

export default function Parole() {
  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Fahndung"
        title="Parole"
        description="Fahndungsliste mit Gefahrenstufen, Verjährung und Registerdaten."
        icon={Crosshair}
      />
      <div className="p-8">
        <Tabs defaultValue="parole">
          <TabsList className="bg-[#0C0E12] border border-zinc-800 rounded-sm p-1 h-auto gap-1 flex-wrap justify-start mb-6">
            <TabsTrigger
              value="parole"
              data-testid="parole-tab-parole"
              className="rounded-sm data-[state=active]:bg-primary data-[state=active]:text-white text-zinc-400 text-xs uppercase tracking-wide font-medium px-4 py-2"
            >
              Parole
            </TabsTrigger>
            <TabsTrigger
              value="resozialisierung"
              data-testid="parole-tab-resozialisierung"
              className="rounded-sm data-[state=active]:bg-primary data-[state=active]:text-white text-zinc-400 text-xs uppercase tracking-wide font-medium px-4 py-2"
            >
              Resozialisierung / Bewährung
            </TabsTrigger>
          </TabsList>
          <TabsContent value="parole">
            <ParoleView mode="aktiv" testidPrefix="parole" bereich="parole" />
          </TabsContent>
          <TabsContent value="resozialisierung">
            <ParoleView mode="aktiv" testidPrefix="resoz" bereich="resozialisierung" />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
